import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
function Staff() {
  return <section data-section-id="1249" id="staff" className="bg-background py-20 text-foreground md:py-28 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="mb-6 font-default text-xs uppercase tracking-[0.25em]" style={{
          color: "var(--secondary)"
        }}>
            スタッフ
          </p>

          <h1 className="font-default text-4xl font-light leading-[1.03] tracking-tight md:text-5xl lg:text-6xl" style={{
          fontFamily: "var(--font-serif)",
          color: "var(--primary)"
        }}>
            当事務所を支えるスタッフ
          </h1>

          <p className="mt-6 max-w-2xl font-default text-lg leading-relaxed" style={{
          color: "var(--muted-foreground)"
        }}>
            The Law Office of Morrie I.
            Levineは、クライアントとの連絡、情報整理、書類準備、法律業務の支援を行う少人数のチームで運営されています。
          </p>
        </div>

        <div className="mt-16 max-w-5xl border-t md:mt-20" style={{
        borderColor: "var(--border)"
      }}>
          {/* Morrie I. Levine */}
          <div className="grid gap-6 border-b py-10 md:grid-cols-[1.2fr_0.8fr] md:items-start md:gap-12 md:py-12" style={{
          borderColor: "var(--border)"
        }}>
            <div>
              <Link to="/MollyLevinAttorneyPage">
                <h2 className="font-default text-2xl font-light leading-tight md:text-3xl" style={{
                fontFamily: "var(--font-serif)",
                color: "var(--primary)"
              }}>
                  モーリー・I・レヴィン
                </h2>
              </Link>

              <p className="mt-3 font-default text-xs uppercase tracking-[0.18em]" style={{
              color: "var(--secondary)"
            }}>
                Syracuse University — B.S., 1980
                <br />
                Syracuse University College of Law — J.D., 1983
              </p>
            </div>

            <div>
              <p className="font-default text-base font-medium" style={{
              color: "var(--foreground)"
            }}>
                弁護士
              </p>

              <p className="mt-2 font-default text-sm" style={{
              color: "var(--muted-foreground)"
            }}>
                フロリダ州・ニューヨーク州
              </p>

              <p className="mt-4 font-default text-sm leading-relaxed" style={{
              color: "var(--muted-foreground)"
            }}>
                モーリー・I・レヴィン弁護士は、1983年以来、南フロリダで法律実務を行っています。ビジネス、不動産取引、遺言・信託・プロベート、弁護士費用に関する案件、および一部の紛争案件を取り扱っています。
              </p>

              <div className="mt-4">
                <Link to="/MollyLevinAttorneyPage" className="font-default text-sm font-medium transition-colors hover:underline" style={{
                color: "var(--primary)"
              }}>
                  詳しいプロフィールを見る →
                </Link>
              </div>
            </div>
          </div>

          {/* Bruce Weihe */}
          <div className="grid gap-6 border-b py-10 md:grid-cols-[1.2fr_0.8fr] md:items-start md:gap-12 md:py-12" style={{
          borderColor: "var(--border)"
        }}>
            <div>
              <h2 className="font-default text-2xl font-light leading-tight md:text-3xl" style={{
              fontFamily: "var(--font-serif)",
              color: "var(--primary)"
            }}>
                Bruce Weihe
              </h2>

              <p className="mt-3 font-default text-xs uppercase tracking-[0.18em]" style={{
              color: "var(--secondary)"
            }}>
                Davidson College — B.A. in History, 1968
                <br />
                University of Florida College of Law — J.D., 1971
              </p>
            </div>

            <div>
              <p className="font-default text-base font-medium" style={{
              color: "var(--foreground)"
            }}>
                弁護士
              </p>

              <p className="mt-2 font-default text-sm" style={{
              color: "var(--muted-foreground)"
            }}>
                フロリダ州
              </p>

              <p className="mt-4 font-default text-sm leading-relaxed" style={{
              color: "var(--muted-foreground)"
            }}>
                Bruce
                Weihe弁護士は、商事訴訟、銀行法、金融機関に関する規制対応を中心に、事業・不動産紛争や破産手続における債権者の代理を取り扱っています。
              </p>

              <div className="mt-4">
                <a href="https://www.bawlawyer.com/" target="_blank" rel="noopener noreferrer" className="font-default text-sm font-medium transition-colors hover:underline" style={{
                color: "var(--primary)"
              }} aria-label="Bruce Weiheの詳しいプロフィールを見る（外部サイト・新しいタブで開きます）">
                  詳しいプロフィールを見る →
                </a>
              </div>
            </div>
          </div>

          {/* Miki Levine */}
          <div className="grid gap-6 border-b py-10 md:grid-cols-[1.2fr_0.8fr] md:items-start md:gap-12 md:py-12" style={{
          borderColor: "var(--border)"
        }}>
            <div>
              <h2 className="font-default text-2xl font-light leading-tight md:text-3xl" style={{
              fontFamily: "var(--font-serif)",
              color: "var(--primary)"
            }}>
                Miki Levine
              </h2>

              <p className="mt-3 font-default text-xs uppercase tracking-[0.18em]" style={{
              color: "var(--secondary)"
            }}>
                Florida Gulf Coast University
                <br />
                4年生 — Criminology専攻
              </p>
            </div>

            <div>
              <p className="font-default text-base font-medium" style={{
              color: "var(--foreground)"
            }}>
                パラリーガル
              </p>

              <p className="mt-4 font-default text-sm leading-relaxed" style={{
              color: "var(--muted-foreground)"
            }}>
                ミキ・レヴィンは、クライアントとの連絡、情報整理、書類準備、その他の事務所業務を支援しています。
              </p>
            </div>
          </div>

          {/* Yasuaki Sawamura */}
          <div className="grid gap-6 border-b py-10 md:grid-cols-[1.2fr_0.8fr] md:items-start md:gap-12 md:py-12" style={{
          borderColor: "var(--border)"
        }}>
            <div>
              <h2 className="font-default text-2xl font-light leading-tight md:text-3xl" style={{
              fontFamily: "var(--font-serif)",
              color: "var(--primary)"
            }}>
                Yasuaki Sawamura
              </h2>

              <p className="mt-3 font-default text-xs uppercase tracking-[0.18em]" style={{
              color: "var(--secondary)"
            }}>
                University of Florida — 2026
                <br />
                Teachers College, Columbia University 大学院進学予定
              </p>
            </div>

            <div>
              <p className="font-default text-base font-medium" style={{
              color: "var(--foreground)"
            }}>
                パラリーガル
              </p>
            </div>
          </div>
        </div>

        <div className="mt-16 max-w-3xl pt-10">
          <h2 className="mb-6 font-default text-2xl font-light leading-tight md:text-3xl" style={{
          fontFamily: "var(--font-serif)",
          color: "var(--primary)"
        }}>
            事務所へのお問い合わせ
          </h2>

          <Button asChild className="rounded-md bg-[hsl(215,50%,15%)] text-white hover:bg-[hsl(215,50%,25%)]">
            <Link to="/ContactUsPage">相談を申し込む</Link>
          </Button>
        </div>
      </div>
    </section>;
}
export default Staff;